import React from 'react';
import { Spin, Empty, Card, Table, Tag } from 'antd';

interface BrandShiftTabProps {
  brandShiftData: any;
  loading: boolean;
}

/**
 * 品牌市场抢占Tab组件
 * 展示品牌市场份额变化矩阵和品牌进退分析
 */
export const BrandShiftTab: React.FC<BrandShiftTabProps> = ({
  brandShiftData,
  loading,
}) => {
  if (loading) {
    return (
      <div style={{ textAlign: 'center', padding: '50px' }}>
        <Spin size="large" tip="正在加载品牌抢占数据...">
          <div style={{ minHeight: 100 }} />
        </Spin>
      </div>
    );
  }

  if (!brandShiftData) {
    return <Empty description="暂无品牌抢占数据" />;
  }

  if (brandShiftData.insufficient_periods) {
    return (
      <Empty 
        description={`需要至少2个周期的数据才能进行品牌市场抢占分析（当前: ${brandShiftData.total_periods}个周期）`}
      />
    );
  }

  return (
    <div style={{ padding: '20px 0' }}>
      <Card title="品牌市场份额变化矩阵" style={{ marginBottom: 24 }}>
        <Table
          dataSource={brandShiftData.shift_matrix}
          rowKey="brand"
          pagination={false}
          columns={[
            {
              title: '品牌',
              dataIndex: 'brand',
              key: 'brand',
              width: 150,
              fixed: 'left' as const,
            },
            {
              title: `${brandShiftData.first_period}份额(%)`,
              dataIndex: 'first_period_share',
              key: 'first_period_share',
              width: 140,
              render: (val: number) => val.toFixed(2),
            },
            {
              title: `${brandShiftData.last_period}份额(%)`,
              dataIndex: 'last_period_share',
              key: 'last_period_share',
              width: 140,
              render: (val: number) => val.toFixed(2),
            },
            {
              title: '份额变化(%)',
              dataIndex: 'share_change',
              key: 'share_change',
              width: 120,
              render: (val: number) => {
                const color = val > 0 ? '#52c41a' : val < 0 ? '#f5222d' : '#666';
                return <span style={{ color, fontWeight: 'bold' }}>{val.toFixed(2)}</span>;
              },
              sorter: (a: any, b: any) => a.share_change - b.share_change,
            },
            {
              title: '变化率(%)',
              dataIndex: 'change_rate',
              key: 'change_rate',
              width: 120,
              render: (val: number) => {
                const color = val > 0 ? '#52c41a' : val < 0 ? '#f5222d' : '#666';
                return <span style={{ color }}>{val.toFixed(2)}%</span>;
              },
            },
          ]}
        />
      </Card>

      <Card title="品牌进退分析">
        <Table
          dataSource={brandShiftData.brand_movements}
          rowKey="brand"
          pagination={false}
          columns={[
            {
              title: '品牌',
              dataIndex: 'brand',
              key: 'brand',
              width: 150,
            },
            {
              title: '状态',
              dataIndex: 'status',
              key: 'status',
              width: 120,
              render: (val: string) => {
                const colorMap: Record<string, string> = {
                  '份额增长': 'green',
                  '份额下降': 'red',
                  '新进入': 'blue',
                  '已退出': 'gray',
                };
                return <Tag color={colorMap[val] || 'default'}>{val}</Tag>;
              },
            },
            {
              title: `${brandShiftData.first_period}份额(%)`,
              dataIndex: 'first_period_share',
              key: 'first_period_share',
              width: 140,
              render: (val: number) => val.toFixed(2),
            },
            {
              title: `${brandShiftData.last_period}份额(%)`,
              dataIndex: 'last_period_share',
              key: 'last_period_share',
              width: 140,
              render: (val: number) => val.toFixed(2),
            },
          ]}
        />
      </Card>
    </div>
  );
};

